import { render, staticRenderFns } from "./RideCopiedUsers.vue?vue&type=template&id=60afbb8b&scoped=true"
import script from "./RideCopiedUsers.vue?vue&type=script&lang=js"
export * from "./RideCopiedUsers.vue?vue&type=script&lang=js"
import style0 from "./RideCopiedUsers.vue?vue&type=style&index=0&id=60afbb8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afbb8b",
  null
  
)

export default component.exports